/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização da div
 */
export default styled.div`
  height: 100%;

  header nav {
    margin: 0;
  }
  .scrollable {
    height: calc(100% - 40px);
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: hidden;
    align-self: stretch;
    flex: 1 0 auto;
    padding-top: 20px;

    .scrollable-content {
      flex: 0 0 100%;
      height: 100%;
      align-self: stretch;
      overflow: auto;
      padding-left: 10px;
    }
  }
`;
